<header class="__header">
  <h4 class="__header-name">{{snapshots[currentIndex]?.deviceName | namize}}</h4>
  <div class="__flex-left-align">
    <awair-caret-switch [initialIndex]="currentIndex"
                        [length]="snapshots?.length"
                        (changeIndex)="onChangeIndex($event)">
    </awair-caret-switch>
  </div>
</header>

<div class="__divider-bottom"></div>

<section class="__body">
  <div class="__score-container">
    <awair-score-dot class="__score-dot"
                     [isOnline]="snapshots[currentIndex]?.isOnline"
                     [score]="snapshots[currentIndex]?.score"
                     [color]="snapshots[currentIndex]?.score | scoreToColor">
    </awair-score-dot>
    <div class="__flex-col">
      <h5 class="__content-header"
          style="margin-top: 4px;">
        Awair Score
      </h5>
      <span class="__value"
            style="margin-top: 4px;">
        <ng-container *ngIf="snapshots[currentIndex] != null && snapshots[currentIndex].isOnline; else disconnected">
          {{snapshots[currentIndex].score | scoreToCondition}}
        </ng-container>
        <ng-template #disconnected>
          Disconnected
        </ng-template>
      </span>
    </div>
  </div>
  <div class="__flex-col">
    <ng-container *ngIf="deviceKeys != null">
      <div class="__sensor-group" *ngFor="let key of deviceKeys">
        <!-- TODO: Should prevent pm10 for now -->
        <ng-container *ngIf="key !== 'pm10'">
          <awair-index-dot class="__index-dot"
                           [color]="snapshots[currentIndex].isOnline ? (snapshots[currentIndex].index[key] | indexToColor) : '#CDD3D8'"
                           [width]="6"
                           [height]="6">
          </awair-index-dot>
          <h5 class="__content-header">{{key | sensorHeader}} ({{key | sensorUnit: snapshots[currentIndex]?.tempUnit}})</h5>
          <ng-container *ngIf="snapshots[currentIndex] != null && snapshots[currentIndex].isOnline; else disconnected">
            <span class="__value __flex-left-align">{{snapshots[currentIndex].sensors[key] | number:'1.0-0'}}</span>
          </ng-container>
          <ng-template #disconnected>
            <span class="__value __flex-left-align">-</span>
          </ng-template>
        </ng-container>
      </div>
    </ng-container>
  </div>
</section>

<div class="__divider-bottom"></div>

<footer class="__footer">
  <table>
    <tr>
      <td class="__footer-header">Model</td>
      <td class="__footer-value">{{snapshots[currentIndex]?.deviceType | deviceTypeNameFull}}</td>
    </tr>
    <tr>
      <td class="__footer-header" style="padding-bottom: 0">Owner</td>
      <td class="__footer-value" style="padding-bottom: 0">{{snapshots[currentIndex]?.firstName | namize}}
        {{snapshots[currentIndex]?.lastName | namize}}
      </td>
    </tr>
    <tr>
      <td></td>
      <td class="__footer-value">{{snapshots[currentIndex]?.email}}</td>
    </tr>
    <tr>
      <td class="__footer-header">Last Updated</td>
      <td class="__footer-value">{{snapshots[currentIndex]?.timestamp | date:'d MMM y, h:mm a'}}</td>
    </tr>
  </table>
</footer>
